/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 0.1.0
 * @changelog
 *
 * 2026-03-13 (0.0.1) (jhoward)
 *   - Add getDateFromEngage function to parse Engage-formatted date strings.
 *
 * 2026-09-22 (0.1.0) (jhoward)
 *   - Also accept the space-separated 'YYYY-MM-DD HH:MM:SS' form tournament results arrive in, which previously failed
 *     the regex and left the raw string on screen.
 *   - Build the Date from its parts rather than re-parsing a string, whose non-ISO form browsers are not required to
 *     read.
 */

//'2026-08-25T00:00:00.000000Z' (offers) or '2026-08-25 00:00:00' (tournament results). Both are read as local time.
const dateRegex = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.\d{6}Z| (\d{2}):(\d{2}):(\d{2}))$/;

export function getDateFromEngage(dateTime: string): Date | null {
  const match = dateTime.match(dateRegex);
  if (match) {
    const [year, month, day] = [match[1], match[2], match[3]].map(Number);
    const [hours, minutes, seconds] = (match[4] !== undefined ? match.slice(4, 7) : match.slice(7, 10)).map(Number);
    const date = new Date(year, month - 1, day, hours, minutes, seconds);
    if (!isNaN(date.getTime()) && date.getDate() === day) {
      return date;
    }
  }

  return null;
}
